import { CurrencyPipe } from "@angular/common";
import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "app/auth/models";
import { PropertyType } from "app/modules/admin/properties/property.model";
import { LandingService } from "../landing.service";
import { Search, Amenities } from "../search.model";
import { environment } from "environments/environment";

@Component({
  selector: "app-header-buscador",
  templateUrl: "./header-buscador.component.html",
  styleUrls: ["./header-buscador.component.scss"],
})
export class HeaderBuscadorComponent implements OnInit {
  public listener: () => void;
  public currentUser: User;
  parametrosBusqueda: Search = {
    types: "",
    propertyTypes: null,
    range: {
      upper: null,
      upperText: "",
      lower: null,
      lowerText: "",
    },
    amenities: [],
    suburbs: null,
    exclusive: false,
  };
  url = environment.URL_AWS;
  domainHome;

  obligatorios: boolean = false;
  precioMal: boolean = false;
  bandProvince: boolean = true;

  modalUbi = null;

  operationTypes = [{ name: "Venta" }, { name: "Renta" }];

  gardenOpt = [
    { name: "Con jardín", value: 1 },
    { name: "Sin jardín", value: 0 },
  ];

  propertyTypes: PropertyType[] = [];

  bedrooms: any[] = [
    { name: "1+", value: 1 },
    { name: "2+", value: 2 },
    { name: "3+", value: 3 },
    { name: "4+", value: 4 },
  ];

  bathrooms: any[] = [
    { name: "0.5+", value: 0.5 },
    { name: "1+", value: 1 },
    { name: "1.5+", value: 1.5 },
    { name: "2+", value: 2 },
    { name: "2.5+", value: 2.5 },
    { name: "3+", value: 3 },
    { name: "3.5+", value: 3.5 },
    { name: "4+", value: 4 },
    { name: "4.5+", value: 4.5 },
  ];

  garageOpt: any[] = [
    { name: "1+", value: 1 },
    { name: "2+", value: 2 },
    { name: "3+", value: 3 },
  ];

  nivelesOpt: any[] = [
    { name: "1+", value: 1 },
    { name: "2+", value: 2 },
    { name: "3+", value: 3 },
  ];

  terrazaOpt = [
    { name: "Con terraza", value: 1 },
    { name: "Sin terraza", value: 0 },
  ];

  amuebladoRentaOpt = [
    { name: "Amueblado", value: 1 },
    { name: "Sin amueblar", value: 0 },
  ];

  yearsAnt = [
    { name: "Menos de 5 años", value: 1 },
    { name: "Menos de 15 años", value: 2 },
    { name: "Menos de 40 años", value: 3 },
    { name: "40 o más años", value: 4 },
  ];

  suburbsBasic: any[] = [];
  suburbLoading = false;

  statesBasic: [] = [];
  stateLoading = false;

  provincesBasic: [] = [];
  provinceLoading = false;

  provinces = [];

  state = {
    name: null,
    id: null,
  };

  amenities: Amenities[];
  exclusive: boolean = false;
  amenities_base: Amenities[];
  amenities_ops: Amenities[];
  years: Amenities = {
    id: 23,
    name: "Años anti",
    icon: "",
    cant: null,
    selected: false,
    status: "1",
    tipo: 1,
    description: "",
    switch: false,
  };

  config;

  showBusquedaAvanzada: boolean = false;
  iconShowBusquedaAvanzada = "chevron-down";

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _LandingService: LandingService,
    private _currencyPipe: CurrencyPipe,
    private _route: ActivatedRoute,
    private renderer: Renderer2
  ) {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    var host = window.location.host;
    const domain = host.split(".")[1];
    let data;
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        domain: host.split(".")[0],
      };
    } else {
      data = {
        domain: environment.DOMAIN,
      };
    }
    this.domainHome = this._router.url;
    this._LandingService.getConfig(data).then(
      (data: any) => {
        this.config = data;
        console.log(this.config);
        if (localStorage.getItem("stateIdCurrent")) {
          this.state = {
            name: localStorage.getItem("stateNameCurrent"),
            id: parseInt(localStorage.getItem("stateIdCurrent")),
          };
        } else {
          this.state = {
            name: this.config?.state?.name,
            id: this.config?.state?.id,
          };
        }
        this.getProvinces(this.state);
        if (localStorage.getItem("provincesCurrent")) {
          this.provinces = JSON.parse(localStorage.getItem("provincesCurrent"));
        } else {
          console.log("provinces", this.config?.province);
          this.provinces?.push(this.config?.province);
        }

        this._LandingService.getStates().then((resp: any) => {
          this.statesBasic = resp;

          console.log("statesBasic", this.statesBasic);
          if (localStorage.getItem("stateIdCurrent")) {
            this.state = {
              name: localStorage.getItem("stateNameCurrent"),
              id: parseInt(localStorage.getItem("stateIdCurrent")),
            };
            this.getProvinces(this.state);
          }
        });
        this.config.phone1 = this.config.phone1.slice(-10);

        const link = document.querySelector("link[rel='icon']") as HTMLAnchorElement | null;
        if (link !== null) {
          link.href = this.url + this.config?.logo;
        }
        document.title = this.config.tradeName;
        const style = document.createElement("style");
        style.innerHTML = `.custom-control-input:checked~.custom-control-label:before {
         background-color:${this.config?.primaryColor} !important;
         border-color:${this.config?.primaryColor} !important;
     }`;

        document.body.appendChild(style);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  ngOnInit(): void {
    this._LandingService.sharingValue$.subscribe((value) => {
      if (value) this.parametrosBusqueda = value;
      else {
        this.parametrosBusqueda = {
          types: "",
          propertyTypes: null,
          range: {
            upper: null,
            upperText: "",
            lower: null,
            lowerText: "",
          },
          amenities: [],
          suburbs: null,
          exclusive: false,
        };
      }
    });
    this._LandingService.allPropertiesTypes().then(
      (data: PropertyType[]) => {
        this.propertyTypes = data;
      },
      (error: any) => {
        console.log(error);
      }
    );

    this._LandingService.allAmenities().then((resp: any) => {
      this.amenities = resp;
      this.amenities_base = [...resp.filter((x) => x.tipo === 1)];
      this.parametrosBusqueda.amenities = resp;
      this.amenities_base.forEach((element) => {
        element.selected = true;
      });
      this.amenities_base = this.amenities_base.sort((a, b) => {
        if (a.id === 9) return -1;
        if (b.id === 9) return 1;
        return 0;
      });
      this.parametrosBusqueda.amenities.forEach((element) => {
        element.switch = false;
        element.cant = null;
      });

      this.amenities_ops = [...resp.filter((x) => x.tipo === 2)];
    });
  }

  register(): void {
    if (this.currentUser) {
      this._router.navigate(["/properties"]);
    } else {
      this._router.navigateByUrl("login/register");
    }
  }

  redirect(): void {
    this._router.navigateByUrl("");
  }

  redirectLogin(): void {
    if (this.currentUser) {
      this._router.navigate(["/properties"]);
    } else {
      this._router.navigateByUrl("login");
    }
  }

  redirectSN(typSN: number) {
    switch (typSN) {
      case 1:
        window.open(this.config.instagramUrl, "_blank");
        break;
      case 2:
        window.open(this.config.tikTokUrl, "_blank");
        break;
      case 3:
        window.open(this.config?.fbUrl, "_blank");
        break;
    }
  }

  nosotros(): void {
    this._router.navigate(["/nosotros"]);
  }

  abreModal(modalBasic): void {
    this.modalService.open(modalBasic, {
      size: "lg",
    });
  }

  abreModal2(modalUbication): void {
    this.modalUbi = this.modalService.open(modalUbication, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  busqueda(): void {
    this.parametrosBusqueda.state_id = this.state.id;
    this.parametrosBusqueda.exclusive = this.exclusive;
    this.parametrosBusqueda.provinces = this.provinces?.map((x) => x.id) || [];
    this.parametrosBusqueda.amenities.push(this.years);
    if (this.parametrosBusqueda.suburbs !== null) {
      this.parametrosBusqueda.suburbsBool = true;
    } else {
      this.parametrosBusqueda.suburbsBool = false;
    }

    const route = this._route.snapshot;

    if (
      this.parametrosBusqueda.types !== "" &&
      this.parametrosBusqueda.propertyTypes !== null &&
      this.parametrosBusqueda.range.lowerText !== "" &&
      this.parametrosBusqueda.range.upperText !== ""
    ) {
      if (this.parametrosBusqueda.range.upper >= this.parametrosBusqueda.range.lower) {
        this._LandingService.sharingValue = this.parametrosBusqueda;
        this.modalService.dismissAll();

        window.location.reload();
      } else {
        this.precioMal = false;
      }
    } else {
      this.obligatorios = true;
    }
  }

  transformAmount(element, type): void {
    if (element.target.value) {
      if (type === 1) {
        this.parametrosBusqueda.range.lower = parseFloat(this.parametrosBusqueda.range.lowerText.replace(",", ""));
        this.parametrosBusqueda.range.lowerText = this._currencyPipe.transform(
          this.parametrosBusqueda.range.lower,
          " ",
          "symbol",
          "1.2-2"
        );
        element.target.value = this.parametrosBusqueda.range.lowerText;
      }

      if (type === 2) {
        this.parametrosBusqueda.range.upper = parseFloat(this.parametrosBusqueda.range.upperText.replace(",", ""));
        this.parametrosBusqueda.range.upperText = this._currencyPipe.transform(
          this.parametrosBusqueda.range.upper,
          " ",
          "symbol",
          "1.2-2"
        );
        element.target.value = this.parametrosBusqueda.range.upperText;
      }
    }
  }

  //   getSuburbs(event): void {
  //   console.log(event);
  //   this._LandingService.getSuburbsById(event.id).then(
  //     (data: any) => {
  //
  //       this.suburbsBasic = data;
  //     }, (error: any) => {
  //       console.log(error);
  //     }
  //   );
  // }

  mostrarBusquedaAvanzada(): void {
    if (this.showBusquedaAvanzada === true) {
      this.iconShowBusquedaAvanzada = "chevron-down";
      this.showBusquedaAvanzada = false;
    } else {
      this.iconShowBusquedaAvanzada = "chevron-up";
      this.showBusquedaAvanzada = true;
    }
    console.log(this.iconShowBusquedaAvanzada);
  }

  checkSelect() {
    this.bandProvince = true;
    console.log(this.provinces);

    this.modalUbi.close();
    // if (!this.province.id) {
    //   this.bandProvince = false;
    // } else {
    //   this.bandProvince = true;
    // }
  }

  getProvinces(event): void {
    this.provinces = [];
    if (event.name) {
      this.state.name = event.name;
      localStorage.setItem("stateNameCurrent", event.name);
    }
    if (event.id) {
      localStorage.setItem("stateIdCurrent", event.id);
      this._LandingService.getProvinceById(event.id).then(
        (data: any) => {
          this.provincesBasic = data;
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
    this.getSuburbs(null);
  }

  getSuburbs(event): void {
    console.log(event);
    this.provinces = event;
    if (!localStorage.getItem("provincesCurrent")) {
      console.log("guardando provincias");
      localStorage.setItem("provincesCurrent", JSON.stringify(this.provinces));
    } else {
      if (event === null) {
        console.log("cargando provincias");
        this.provinces = JSON.parse(localStorage.getItem("provincesCurrent"));
        console.log(this.provinces);
      } else {
        console.log("guardando provincias");
        localStorage.setItem("provincesCurrent", JSON.stringify(this.provinces));
      }
    }
    this.suburbsBasic = [];
    this.provinces?.forEach((province) => {
      this._LandingService.getSuburbsById(province.id).then(
        (data: any) => {
          this.suburbsBasic = this.suburbsBasic.concat(data);
          this.suburbsBasic = this.suburbsBasic.sort((a, b) => {
            if (a.postalCode < b.postalCode) return -1;
            if (a.postalCode > b.postalCode) return 1;
            return 0;
          });
        },
        (error: any) => {
          console.log(error);
        }
      );
    });
  }

  public onQtrInputChange(event: any, id) {
    if (id.toString() === "1") {
      if (event.replace(/\D/g, "") === "") {
        this.parametrosBusqueda.range.lower = 0;
      } else {
        this.parametrosBusqueda.range.lower = Number(event.replace(/\D/g, ""));
      }
    } else {
      if (event.replace(/\D/g, "") === "") {
        this.parametrosBusqueda.range.upper = 0;
      } else {
        this.parametrosBusqueda.range.upper = Number(event.replace(/\D/g, ""));
      }
    }
  }

  public onFocusCommaInput(id) {
    if (id.toString() === "1") {
      this.listener = this.renderer.listen("window", "keyup", (event) => {
        this.parametrosBusqueda.range.lowerText = (<HTMLInputElement>document.getElementById("minPrice")).value.replace(
          /[^\d,]/g,
          ""
        );
      });
    } else {
      this.listener = this.renderer.listen("window", "keyup", (event) => {
        this.parametrosBusqueda.range.upperText = (<HTMLInputElement>document.getElementById("maxPrie")).value.replace(
          /[^\d,]/g,
          ""
        );
      });
    }
  }

  public onBlurCommaInput() {
    this.listener();
  }
}
